import "../assets/css/certifications.css";
import React, { useEffect } from "react";
import { animation, headerSet, showNavLink } from "../Helper/CssHelper";
// import CertificationsData from "../data/CertificationsData";

function Certifications(props) {
  const CertificationsData = props.CertificationsData;

  useEffect(() => {
    headerSet("Certifications | Justin Dsouza");
    showNavLink("certifications", "certifications-section");
    animation("certifications-section");
  }, []);
  return (
    <div>
      <section
        id="certifications-section"
        className="certifications section-show"
      >
        <div className="container">
          <div className="section-title">
            <h2>Certifications</h2>
            <p>My Credentials</p>
          </div>

          {/* <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <ul id="certifications-flters">
                <li data-filter="*" className="filter-active">
                  All
                </li>
                <li data-filter=".filter-app">App</li>
                <li data-filter=".filter-card">Card</li>
                <li data-filter=".filter-web"> Web</li>
              </ul>
            </div>
          </div> */}
          {CertificationsData.specialization && (
            <div className="row">
              <h2>Specializations</h2>
              {CertificationsData.specialization &&
                CertificationsData.specialization.map((specialization, index) => {
                  return (
                    <div
                      className="col-md-6 certifications-item filter-app"
                      key={index}
                    >
                      <div className="card h-100">
                        {specialization.Name && (
                          <div className="card-header h5 pb-0">
                            {specialization.Name}
                          </div>
                        )}
                        {specialization.GivenBy && (
                          <div className="card-header pb-0 givenBy">
                            {specialization.GivenBy}
                          </div>
                        )}
                        <div className="card-body">
                          {specialization.skillsGained && (
                            <div className="card-text d-none d-lg-block">
                              <h5>Skills Gained</h5>
                              <div className="d-flex align-content-start flex-wrap">
                                {specialization.skillsGained &&
                                  specialization.skillsGained.map(
                                    (skill, index) => {
                                      return (
                                        <span
                                          className="skill-pills m-1 py-1 px-2 rounded-pill h6"
                                          key={index}
                                        >
                                          {skill.skill}
                                        </span>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          )}
                        </div>
                        {specialization.VerificationLink && (
                          <div className="card-footer">
                            <a
                              href={specialization.VerificationLink}
                              target="_blank"
                              rel="noreferrer"
                              className="btn align-self-end certificate-link"
                            >
                              Certificate Link
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
          {CertificationsData.certifiations && (
            <div className="row">
              <h2>Certificates</h2>
              {CertificationsData.certifiations &&
                CertificationsData.certifiations.map((certificate, index) => {
                  return (
                    <div
                      className="col-md-6 certifications-item filter-app"
                      key={index}
                    >
                      <div className="card h-100">
                        {certificate.Name && (
                          <div className="card-header h5 pb-0">
                            {certificate.Name}
                          </div>
                        )}
                        {certificate.GivenBy && (
                          <div className="card-header pb-0 givenBy">
                            {certificate.GivenBy}
                          </div>
                        )}
                        <div className="card-body">
                          {certificate.skillsGained && (
                            <div className="card-text d-none d-lg-block">
                              <h5>Skills Gained</h5>
                              <div className="d-flex align-content-start flex-wrap">
                                {certificate.skillsGained &&
                                  certificate.skillsGained.map(
                                    (skill, index) => {
                                      return (
                                        <span
                                          className="skill-pills m-1 py-1 px-2 rounded-pill h6"
                                          key={index}
                                        >
                                          {skill.skill}
                                        </span>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          )}
                        </div>
                        {certificate.VerificationLink && (
                          <div className="card-footer">
                            <a
                              href={certificate.VerificationLink}
                              target="_blank"
                              rel="noreferrer"
                              className="btn align-self-end certificate-link"
                            >
                              Certificate Link
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Certifications;
